function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
class GalleryItem extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onMouseEnter", event => {
      if (this.src2) {
        this.src = this.src2;
        this.forceUpdate();
      }
    });
    _defineProperty(this, "onMouseLeave", event => {
      this.src = this.originalSrc;
      this.forceUpdate();
    });
    this.item = this.props.item;
    let baseImageUrl = this.props.baseImageUrl;
    this.originalSrc = baseImageUrl + "/" + this.item.image + "?width=500";
    this.src = baseImageUrl + "/" + this.item.image + "?width=500";
    this.src2 = null;
    let altImages = this.item.altImages;
    if (altImages && altImages.length) {
      if (altImages[1]) this.src2 = baseImageUrl + "/" + altImages[1] + "?width=500";
    }
  }
  render() {
    const {
      item,
      baseImageUrl
    } = this.props;
    let imageUrl = baseImageUrl + "/" + item.image + "?width=500";
    return /*#__PURE__*/React.createElement("gallery-item", null, item.badge && /*#__PURE__*/React.createElement("div", {
      className: "gallery-item-badge"
    }, item.badge), /*#__PURE__*/React.createElement("a", {
      className: "image-container",
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave
    }, /*#__PURE__*/React.createElement("img", {
      src: this.src,
      alt: item.name,
      className: "gallery-item-image"
    })), /*#__PURE__*/React.createElement("a", {
      className: "gallery-item-info"
    }, item.collection && /*#__PURE__*/React.createElement("span", {
      className: "gallery-item-collection"
    }, item.collection), /*#__PURE__*/React.createElement("span", {
      className: "gallery-item-title"
    }, item.name), /*#__PURE__*/React.createElement("span", {
      className: "gallery-item-sku"
    }, item.sku), item.grade && /*#__PURE__*/React.createElement("span", {
      className: "gallery-item-grade"
    }, item.grade), item.price && /*#__PURE__*/React.createElement("span", {
      className: "gallery-item-price"
    }, "From ", item.price), /*#__PURE__*/React.createElement("div", {
      className: "gallery-item-like"
    }, /*#__PURE__*/React.createElement("img", {
      src: "/images/icons/heart-icon.png",
      alt: "Like",
      onClick: () => this.props.onLike(item)
    }))));
  }
}
export class ShoppingGallery extends React.Component {
  constructor(props) {
    super(props);
  }
  get items() {
    let data = this.props.data;
    let index = 0;
    return data.map(item => {
      return /*#__PURE__*/React.createElement(GalleryItem, {
        key: item.id,
        item: item,
        baseImageUrl: this.props.baseImageUrl,
        onLike: this.props.onLike
      });
    });
  }
  render() {
    return /*#__PURE__*/React.createElement("shopping-gallery", null, this.items);
  }
}